export const FETCH_FINAL_REQUEST_APPROVALS = "FETCH_FINAL_REQUEST_APPROVALS";
export const EDIT_FINAL_REQUEST_APPROVAL = "EDIT_FINAL_REQUEST_APPROVAL";
